import { object, string } from "yup";

const validationSchema = object().shape({
  name: string().required("You must enter a search name"),
});

export default () => validationSchema;
